/**
 * FILE WAS AUTOGENERATED
 *
 * **DO NOT EDIT THIS FILE MANUALLY** IF YOU DO NOT UNDERSTAND WHAT IS HERE AND HOW
 */
import { z } from 'zod'

import {
	ActiveFilterDtoValidation,
	AdultReservationGuestsDtoValidation,
	AuthenticationRequestDtoValidation,
	BillingAddressValidation,
	BlogDtoValidation,
	BookableNotPackagedFeatureDtoValidation,
	BookableNotPackagedFeatureOptionDtoValidation,
	BookablePackageDtoValidation,
	BookablePackagedFeatureDtoValidation,
	BookablePackagedFeatureOptionDtoValidation,
	ChangelogOfferDtoValidation,
	ChangelogOffersMapValidation,
	ChatClientChatUpdateRequestValidation,
	ChatClientChatsRequestValidation,
	ChatClientChatsResponseValidation,
	ChatClientMessageCreateRequestValidation,
	ChatClientMessageCreateResponseValidation,
	ChatClientMessagesRequestValidation,
	ChatClientMessagesResponseValidation,
	ChatDTOValidation,
	ChatFromEnumValidation,
	ChatMessageDTOValidation,
	ChatMessageStatusEnumValidation,
	ChatMessageTextAndSearchInfoDtoValidation,
	ChatSearchInfoDTOValidation,
	ChatSearchInfoFilterItemOptionValidation,
	ChatSearchInfoFilterItemRangeParamsValidation,
	ChatTabEnumValidation,
	CheckInFeatureDtoValidation,
	CheckInFeatureOptionDtoValidation,
	ChilldrenReservationGuestsDtoValidation,
	ContactDataValidation,
	CountElementsDtoValidation,
	CreateReasonDtoValidation,
	CreateReservationDtoValidation,
	CreateSetRequestValidation,
	DeviceValidation,
	DislikedOfferIdsListDtoValidation,
	FeatureGroupValidation,
	FlagSearchDtoValidation,
	GenderEnumValidation,
	GeolocationAddressValidation,
	GeolocationDtoValidation,
	GeolocationValidation,
	GuestPetDtoValidation,
	GuestPetTypeEnumValidation,
	GuestQuantityDtoValidation,
	HotelDynamicDataDtoValidation,
	HotelSearchDtoValidation,
	HotelStaticDataDtoValidation,
	ImageDtoValidation,
	ImagePropertiesDtoValidation,
	IncludedFeatureDtoValidation,
	IncludedFeatureOptionDtoValidation,
	InfoProvidedValidation,
	IntegrationSearchDtoValidation,
	JWTTokenValidation,
	LikeIdsResponseValidation,
	LikesResponseDtoValidation,
	MetadataValidation,
	ModalEnumValidation,
	NotificationActionEnumValidation,
	NotificationActionOpenModalChatAssistantValidation,
	NotificationActionRedirectToComparisonValidation,
	NotificationActionRedirectToHomeValidation,
	NotificationActionRedirectToReservationValidation,
	NotificationActionRedirectToRoomOfferWithOfferIdValidation,
	NotificationActionStartTutorialValidation,
	NotificationClientListResponseDtoValidation,
	NotificationClientUpdateRequestDtoValidation,
	NotificationDtoRequestValidation,
	NotificationDtoValidation,
	NotificationStatusEnumValidation,
	OfferCreateResponseDtoValidation,
	OfferDynamicDataDtoValidation,
	OfferIdsDtoValidation,
	OfferMetaDataDtoValidation,
	OfferPromoCodeRequestValidation,
	OfferPromoCodeResponseValidation,
	OfferResponseDtoValidation,
	OfferResponseMetaDataDtoValidation,
	OfferResponseStaticDataDtoValidation,
	OfferStatusEnumValidation,
	OfferValidationResponseDtoValidation,
	OffersResponseDtoValidation,
	PackagePriceDtoValidation,
	PageEnumValidation,
	PaginationDtoValidation,
	PaymentCardValidation,
	PaymentDataValidation,
	PhoneInfoValidation,
	PointDtoValidation,
	PriceCurrencyEnumValidation,
	PriceDtoValidation,
	RangeParamsDtoValidation,
	ReasonDtoValidation,
	ReservationCancelledRequestDtoValidation,
	ReservationDtoValidation,
	ReservationStatusDtoValidation,
	ReservationStatusEnumValidation,
	ResponseErrorDtoValidation,
	ResponseMessageDtoValidation,
	ReviewAuthorDtoValidation,
	ReviewContentDtoValidation,
	ReviewDtoValidation,
	ReviewMetaDataDtoValidation,
	ReviewOwnerResponseDtoValidation,
	ReviewRatingElementDtoValidation,
	ReviewRequestDtoValidation,
	ReviewScoreDtoValidation,
	ReviewTravelerTypeDtoValidation,
	ReviewTripDetailsDtoValidation,
	ReviewsDtoValidation,
	ReviewsResponseDtoValidation,
	RoomDynamicDataDtoValidation,
	RoomFaqDtoValidation,
	RoomReviewAndFaqDtoValidation,
	RoomReviewDtoValidation,
	RoomStaticDataDtoValidation,
	SaveDislikeResponseDtoValidation,
	SaveOfferRequestDtoValidation,
	SaveOfferStaticDataDtoValidation,
	SearchOffersDtoValidation,
	SearchResponseDtoValidation,
	SetModeEnumValidation,
	SetResponseDtoValidation,
	SetsResponseDtoValidation,
	SocketErrorDtoValidation,
	SocketSuccessResponseValidation,
	SortDtoValidation,
	SortResponseDtoValidation,
	StayDtoValidation,
	StayPeriodDtoValidation,
	SupplierInfoDtoValidation,
	TaxDtoValidation,
	ThreeDsDataValidation,
	UpdateSetRequestDtoValidation,
	UserDtoValidation
} from '../validations'

export const OfferStatusEnum = z
	.enum([
		'AVAILABLE',
		'EXPIRED_DATES',
		'NOT_AVAILABLE',
		'PAYMENT_PENDING',
		'PAYMENT_FAILED',
		'RESERVATION_PENDING',
		'RESERVATION_FAILED',
		'RESERVATION_CANCELLED',
		'RESERVATION_CANCEL_PENDING',
		'RESERVATION_CANCEL_FAILED',
		'RESERVED',
		'TRIP_COMPLETED'
	])
	.superRefine(OfferStatusEnumValidation)
export type OfferStatusEnum = z.infer<typeof OfferStatusEnum>

export const OfferResponseMetaDataDto = z
	.object({
		wwtOfferId: z.string().uuid(),
		nonPersistingOfferId: z.string().min(1),
		integrationName: z
			.string()
			.min(1)
			.regex(/.*_INTEGRATION/),
		integrationHotelId: z.string().min(1),
		integrationRoomId: z.string().min(1),
		status: OfferStatusEnum,
		statusUpdateTimestamp: z.string()
	})
	.superRefine(OfferResponseMetaDataDtoValidation)
export type OfferResponseMetaDataDto = z.infer<typeof OfferResponseMetaDataDto>

export const GuestPetTypeEnum = z
	.enum(['DOG', 'CAT', 'OTHER'])
	.superRefine(GuestPetTypeEnumValidation)
export type GuestPetTypeEnum = z.infer<typeof GuestPetTypeEnum>

export const GuestPetDto = z
	.object({ type: GuestPetTypeEnum, weight: z.string().min(1) })
	.superRefine(GuestPetDtoValidation)
export type GuestPetDto = z.infer<typeof GuestPetDto>

export const GuestQuantityDto = z
	.object({
		adultsQuantity: z.coerce.number().int().gte(1).lte(10),
		ageOfChildren: z.array(z.coerce.number().int().gte(0).lte(17)).optional(),
		pets: z.array(GuestPetDto).optional()
	})
	.superRefine(GuestQuantityDtoValidation)
export type GuestQuantityDto = z.infer<typeof GuestQuantityDto>

export const FeatureGroup = z
	.object({
		name: z.string().min(1),
		iconName: z.string().min(1).optional(),
		tabName: z.string().min(1).optional(),
		priority: z.number().int().gte(1).optional(),
		description: z.string().min(1).optional()
	})
	.superRefine(FeatureGroupValidation)
export type FeatureGroup = z.infer<typeof FeatureGroup>

export const PriceCurrencyEnum = z
	.enum(['USD', 'EUR'])
	.superRefine(PriceCurrencyEnumValidation)
export type PriceCurrencyEnum = z.infer<typeof PriceCurrencyEnum>

export const TaxDto = z
	.object({
		name: z.string().min(1),
		amount: z.number().gte(0),
		isIncluded: z.boolean(),
		currency: PriceCurrencyEnum.optional()
	})
	.superRefine(TaxDtoValidation)
export type TaxDto = z.infer<typeof TaxDto>

export const PackagePriceDto = z
	.object({
		amount: z.number().gte(1),
		currency: PriceCurrencyEnum.optional(),
		taxes: z.array(TaxDto).optional(),
		wwtCommission: z.number().optional(),
		noShow: z.number().optional(),
		wwtPromoCodeDiscount: z.number().optional()
	})
	.superRefine(PackagePriceDtoValidation)
export type PackagePriceDto = z.infer<typeof PackagePriceDto>

export const BookablePackageDto = z
	.object({
		bookingKey: z.string().min(1),
		price: PackagePriceDto,
		roomsAvailable: z.number().int().optional(),
		description: z.string().min(1).optional(),
		isSelected: z.boolean()
	})
	.superRefine(BookablePackageDtoValidation)
export type BookablePackageDto = z.infer<typeof BookablePackageDto>

export const BookablePackagedFeatureOptionDto = z
	.object({
		wwtOptionId: z.string().optional(),
		name: z.string().min(1),
		description: z.string().min(1).optional(),
		wwtPriority: z.number().int().gte(1).optional(),
		integrationPriority: z.number().int().gte(1).optional(),
		imageUrl: z.string().min(1).optional(),
		iconName: z.string().min(1).optional(),
		packages: z.array(BookablePackageDto).min(1).max(2147483647),
		isExist: z.boolean(),
		isSelected: z.boolean(),
		isWarning: z.boolean().optional(),
		expiredAt: z.string().datetime({ offset: true }).optional(),
		isFromReview: z.boolean().optional(),
		isCustom: z.boolean().optional()
	})
	.superRefine(BookablePackagedFeatureOptionDtoValidation)
export type BookablePackagedFeatureOptionDto = z.infer<
	typeof BookablePackagedFeatureOptionDto
>

export const BookablePackagedFeatureDto = z
	.object({
		wwtFeatureId: z.string().optional(),
		name: z.string().min(1),
		description: z.string().min(1).optional(),
		imageUrl: z.string().min(1).url().optional(),
		iconName: z.string().min(1).optional(),
		wwtPriority: z.number().int().gte(1).optional(),
		integrationPriority: z.number().int().gte(1).optional(),
		group: FeatureGroup.optional(),
		options: z.array(BookablePackagedFeatureOptionDto).min(1).max(2147483647)
	})
	.superRefine(BookablePackagedFeatureDtoValidation)
export type BookablePackagedFeatureDto = z.infer<
	typeof BookablePackagedFeatureDto
>

export const PriceDto = z
	.object({ amount: z.number().gte(0), currency: PriceCurrencyEnum.optional() })
	.superRefine(PriceDtoValidation)
export type PriceDto = z.infer<typeof PriceDto>

export const BookableNotPackagedFeatureOptionDto = z
	.object({
		wwtOptionId: z.string().optional(),
		name: z.string().min(1),
		description: z.string().min(1).optional(),
		wwtPriority: z.number().int().gte(1).optional(),
		integrationPriority: z.number().int().gte(1).optional(),
		imageUrl: z.string().min(1).optional(),
		iconName: z.string().min(1).optional(),
		price: PriceDto,
		isExist: z.boolean(),
		isSelected: z.boolean(),
		expiredAt: z.string().datetime({ offset: true }).optional(),
		isFromReview: z.boolean().optional(),
		isWarning: z.boolean().optional(),
		isCustom: z.boolean().optional()
	})
	.superRefine(BookableNotPackagedFeatureOptionDtoValidation)
export type BookableNotPackagedFeatureOptionDto = z.infer<
	typeof BookableNotPackagedFeatureOptionDto
>

export const BookableNotPackagedFeatureDto = z
	.object({
		wwtFeatureId: z.string().optional(),
		name: z.string().min(1),
		description: z.string().min(1).optional(),
		imageUrl: z.string().min(1).url().optional(),
		iconName: z.string().min(1).optional(),
		wwtPriority: z.number().int().gte(1).optional(),
		integrationPriority: z.number().int().gte(1).optional(),
		group: FeatureGroup.optional(),
		options: z.array(BookableNotPackagedFeatureOptionDto).min(2).max(2147483647)
	})
	.superRefine(BookableNotPackagedFeatureDtoValidation)
export type BookableNotPackagedFeatureDto = z.infer<
	typeof BookableNotPackagedFeatureDto
>

export const CheckInFeatureOptionDto = z
	.object({
		wwtOptionId: z.string().optional(),
		name: z.string().min(1),
		description: z.string().min(1).optional(),
		wwtPriority: z.number().int().gte(1).optional(),
		integrationPriority: z.number().int().gte(1).optional(),
		imageUrl: z.string().min(1).optional(),
		iconName: z.string().min(1).optional(),
		price: PriceDto.optional(),
		isExist: z.boolean(),
		isSelected: z.boolean(),
		expiredAt: z.string().datetime({ offset: true }).optional(),
		isFromReview: z.boolean().optional(),
		isWarning: z.boolean().optional(),
		isCustom: z.boolean().optional()
	})
	.superRefine(CheckInFeatureOptionDtoValidation)
export type CheckInFeatureOptionDto = z.infer<typeof CheckInFeatureOptionDto>

export const CheckInFeatureDto = z
	.object({
		wwtFeatureId: z.string().optional(),
		name: z.string().min(1),
		description: z.string().min(1).optional(),
		imageUrl: z.string().min(1).url().optional(),
		iconName: z.string().min(1).optional(),
		wwtPriority: z.number().int().gte(1).optional(),
		integrationPriority: z.number().int().gte(1).optional(),
		group: FeatureGroup.optional(),
		options: z.array(CheckInFeatureOptionDto).min(1).max(2147483647)
	})
	.superRefine(CheckInFeatureDtoValidation)
export type CheckInFeatureDto = z.infer<typeof CheckInFeatureDto>

export const IncludedFeatureOptionDto = z
	.object({
		wwtOptionId: z.string().optional(),
		name: z.string().min(1),
		description: z.string().min(1).optional(),
		wwtPriority: z.number().int().gte(1).optional(),
		integrationPriority: z.number().int().gte(1).optional(),
		imageUrl: z.string().min(1).optional(),
		iconName: z.string().min(1).optional(),
		isExist: z.boolean(),
		expiredAt: z.string().datetime({ offset: true }).optional(),
		isFromReview: z.boolean().optional(),
		isWarning: z.boolean().optional(),
		isCustom: z.boolean().optional()
	})
	.superRefine(IncludedFeatureOptionDtoValidation)
export type IncludedFeatureOptionDto = z.infer<typeof IncludedFeatureOptionDto>

export const IncludedFeatureDto = z
	.object({
		wwtFeatureId: z.string().optional(),
		name: z.string().min(1),
		description: z.string().min(1).optional(),
		imageUrl: z.string().min(1).url().optional(),
		iconName: z.string().min(1).optional(),
		wwtPriority: z.number().int().gte(1).optional(),
		integrationPriority: z.number().int().gte(1).optional(),
		group: FeatureGroup.optional(),
		option: IncludedFeatureOptionDto
	})
	.superRefine(IncludedFeatureDtoValidation)
export type IncludedFeatureDto = z.infer<typeof IncludedFeatureDto>

export const RoomReviewDto = z
	.object({
		rate: z.number(),
		nameReviewer: z.string(),
		reviewTitle: z.string(),
		reviewDescription: z.string(),
		reviewDate: z.string()
	})
	.superRefine(RoomReviewDtoValidation)
export type RoomReviewDto = z.infer<typeof RoomReviewDto>

export const RoomFaqDto = z
	.object({ faq: z.string(), answer: z.string() })
	.superRefine(RoomFaqDtoValidation)
export type RoomFaqDto = z.infer<typeof RoomFaqDto>

export const RoomReviewAndFaqDto = z
	.object({
		roomReviewDto: z.array(RoomReviewDto),
		averageRoomRate: z.number(),
		roomFaqDto: z.array(RoomFaqDto)
	})
	.partial()
	.superRefine(RoomReviewAndFaqDtoValidation)
export type RoomReviewAndFaqDto = z.infer<typeof RoomReviewAndFaqDto>

export const RoomDynamicDataDto = z
	.object({
		wwtRoomDynamicDataId: z.string().optional(),
		nonPersistingOfferId: z.string(),
		name: z.string().min(1),
		checkIn: z.string(),
		checkOut: z.string(),
		guestQuantity: GuestQuantityDto,
		quantity: z.number().int().gte(1),
		bookablePackagedFeatures: z
			.array(BookablePackagedFeatureDto)
			.min(1)
			.max(2147483647),
		bookableNotPackagedFeatures: z
			.array(BookableNotPackagedFeatureDto)
			.min(1)
			.max(2147483647)
			.optional(),
		checkInFeatures: z
			.array(CheckInFeatureDto)
			.min(1)
			.max(2147483647)
			.optional(),
		includedFeatures: z
			.array(IncludedFeatureDto)
			.min(1)
			.max(2147483647)
			.optional(),
		roomReviewAndFaqDto: RoomReviewAndFaqDto.optional()
	})
	.superRefine(RoomDynamicDataDtoValidation)
export type RoomDynamicDataDto = z.infer<typeof RoomDynamicDataDto>

export const HotelDynamicDataDto = z
	.object({
		wwtHotelDynamicDataId: z.number().int().optional(),
		nonPersistingOfferId: z.string(),
		destinationName: z.string().min(1),
		averageRate: z.number().gte(0).optional(),
		reviewCount: z.number().int().gte(0).optional(),
		checkInFeatures: z
			.array(CheckInFeatureDto)
			.min(1)
			.max(2147483647)
			.optional()
	})
	.superRefine(HotelDynamicDataDtoValidation)
export type HotelDynamicDataDto = z.infer<typeof HotelDynamicDataDto>

export const OfferDynamicDataDto = z
	.object({
		roomDynamicData: RoomDynamicDataDto,
		hotelDynamicData: HotelDynamicDataDto
	})
	.superRefine(OfferDynamicDataDtoValidation)
export type OfferDynamicDataDto = z.infer<typeof OfferDynamicDataDto>

export const ImagePropertiesDto = z
	.object({
		imageUrl: z.string().url(),
		width: z.number().int().gte(1).optional(),
		height: z.number().int().gte(1).optional(),
		size: z.string().min(1).optional()
	})
	.superRefine(ImagePropertiesDtoValidation)
export type ImagePropertiesDto = z.infer<typeof ImagePropertiesDto>

export const ImageDto = z
	.object({
		resolution: z.array(ImagePropertiesDto).min(1),
		description: z.string().min(1).optional(),
		category: z.string().min(1).optional()
	})
	.superRefine(ImageDtoValidation)
export type ImageDto = z.infer<typeof ImageDto>

export const RoomStaticDataDto = z
	.object({
		wwtRoomStaticDataId: z.number().int(),
		id: z.string(),
		description: z.string().min(1),
		images: z.array(ImageDto).min(1).max(2147483647),
		includedFeatures: z.array(IncludedFeatureDto).min(1).max(2147483647),
		maxAdults: z.number().int(),
		maxChildren: z.number().int(),
		minAdults: z.number().int()
	})
	.partial()
	.superRefine(RoomStaticDataDtoValidation)
export type RoomStaticDataDto = z.infer<typeof RoomStaticDataDto>

export const PhoneInfo = z
	.object({
		description: z.string().min(1).optional(),
		phoneNumber: z.string().min(1)
	})
	.superRefine(PhoneInfoValidation)
export type PhoneInfo = z.infer<typeof PhoneInfo>

export const BlogDto = z
	.object({
		messages: z.array(z.string().min(1).max(2147483647)).min(1).max(2147483647)
	})
	.superRefine(BlogDtoValidation)
export type BlogDto = z.infer<typeof BlogDto>

export const GeolocationAddress = z
	.object({
		country: z.string(),
		countryCode: z.string(),
		region: z.string().optional(),
		city: z.string(),
		streetAddress: z.string()
	})
	.superRefine(GeolocationAddressValidation)
export type GeolocationAddress = z.infer<typeof GeolocationAddress>

export const Geolocation = z
	.object({
		longitude: z.number(),
		latitude: z.number(),
		address: GeolocationAddress
	})
	.superRefine(GeolocationValidation)
export type Geolocation = z.infer<typeof Geolocation>

export const HotelStaticDataDto = z
	.object({
		wwtHotelStaticDataId: z.number().int().optional(),
		id: z.string().min(1),
		name: z.string().min(1),
		description: z.string().min(1).optional(),
		phones: z.array(PhoneInfo).optional(),
		email: z.string().min(1).email().optional(),
		web: z.string().min(1).url().optional(),
		blog: BlogDto.optional(),
		geolocation: Geolocation,
		includedFeatures: z
			.array(IncludedFeatureDto)
			.min(1)
			.max(2147483647)
			.optional(),
		images: z.array(ImageDto).min(1).max(2147483647).optional(),
		accommodationType: z.string().min(1),
		category: z.string().min(1).optional(),
		stars: z.number().int().gte(-1).lte(5)
	})
	.superRefine(HotelStaticDataDtoValidation)
export type HotelStaticDataDto = z.infer<typeof HotelStaticDataDto>

export const OfferResponseStaticDataDto = z
	.object({
		roomStaticData: RoomStaticDataDto,
		hotelStaticData: HotelStaticDataDto
	})
	.superRefine(OfferResponseStaticDataDtoValidation)
export type OfferResponseStaticDataDto = z.infer<
	typeof OfferResponseStaticDataDto
>

export const OfferResponseDto = z
	.object({
		metaData: OfferResponseMetaDataDto,
		offerDynamicData: OfferDynamicDataDto,
		offerStaticData: OfferResponseStaticDataDto
	})
	.superRefine(OfferResponseDtoValidation)
export type OfferResponseDto = z.infer<typeof OfferResponseDto>

export const ResponseErrorDto = z
	.object({
		time: z.string().datetime({ offset: true }),
		statusCode: z.enum([
			'100 CONTINUE',
			'101 SWITCHING_PROTOCOLS',
			'102 PROCESSING',
			'103 EARLY_HINTS',
			'103 CHECKPOINT',
			'200 OK',
			'201 CREATED',
			'202 ACCEPTED',
			'203 NON_AUTHORITATIVE_INFORMATION',
			'204 NO_CONTENT',
			'205 RESET_CONTENT',
			'206 PARTIAL_CONTENT',
			'207 MULTI_STATUS',
			'208 ALREADY_REPORTED',
			'226 IM_USED',
			'300 MULTIPLE_CHOICES',
			'301 MOVED_PERMANENTLY',
			'302 FOUND',
			'302 MOVED_TEMPORARILY',
			'303 SEE_OTHER',
			'304 NOT_MODIFIED',
			'305 USE_PROXY',
			'307 TEMPORARY_REDIRECT',
			'308 PERMANENT_REDIRECT',
			'400 BAD_REQUEST',
			'401 UNAUTHORIZED',
			'402 PAYMENT_REQUIRED',
			'403 FORBIDDEN',
			'404 NOT_FOUND',
			'405 METHOD_NOT_ALLOWED',
			'406 NOT_ACCEPTABLE',
			'407 PROXY_AUTHENTICATION_REQUIRED',
			'408 REQUEST_TIMEOUT',
			'409 CONFLICT',
			'410 GONE',
			'411 LENGTH_REQUIRED',
			'412 PRECONDITION_FAILED',
			'413 PAYLOAD_TOO_LARGE',
			'413 REQUEST_ENTITY_TOO_LARGE',
			'414 URI_TOO_LONG',
			'414 REQUEST_URI_TOO_LONG',
			'415 UNSUPPORTED_MEDIA_TYPE',
			'416 REQUESTED_RANGE_NOT_SATISFIABLE',
			'417 EXPECTATION_FAILED',
			'418 I_AM_A_TEAPOT',
			'419 INSUFFICIENT_SPACE_ON_RESOURCE',
			'420 METHOD_FAILURE',
			'421 DESTINATION_LOCKED',
			'422 UNPROCESSABLE_ENTITY',
			'423 LOCKED',
			'424 FAILED_DEPENDENCY',
			'425 TOO_EARLY',
			'426 UPGRADE_REQUIRED',
			'428 PRECONDITION_REQUIRED',
			'429 TOO_MANY_REQUESTS',
			'431 REQUEST_HEADER_FIELDS_TOO_LARGE',
			'451 UNAVAILABLE_FOR_LEGAL_REASONS',
			'500 INTERNAL_SERVER_ERROR',
			'501 NOT_IMPLEMENTED',
			'502 BAD_GATEWAY',
			'503 SERVICE_UNAVAILABLE',
			'504 GATEWAY_TIMEOUT',
			'505 HTTP_VERSION_NOT_SUPPORTED',
			'506 VARIANT_ALSO_NEGOTIATES',
			'507 INSUFFICIENT_STORAGE',
			'508 LOOP_DETECTED',
			'509 BANDWIDTH_LIMIT_EXCEEDED',
			'510 NOT_EXTENDED',
			'511 NETWORK_AUTHENTICATION_REQUIRED'
		]),
		errorMessage: z.array(z.string()).optional(),
		stackTrace: z.array(z.string()).optional()
	})
	.superRefine(ResponseErrorDtoValidation)
export type ResponseErrorDto = z.infer<typeof ResponseErrorDto>

export const OfferMetaDataDto = z
	.object({
		wwtOfferId: z.string().uuid().optional(),
		nonPersistingOfferId: z.string().min(1),
		integrationName: z
			.string()
			.min(1)
			.regex(/.*_INTEGRATION/),
		integrationHotelId: z.string().min(1),
		integrationRoomId: z.string().min(1),
		status: OfferStatusEnum,
		statusUpdateTimestamp: z.string()
	})
	.superRefine(OfferMetaDataDtoValidation)
export type OfferMetaDataDto = z.infer<typeof OfferMetaDataDto>

export const SaveOfferRequestDto = z
	.object({ metaData: OfferMetaDataDto, offerDynamicData: OfferDynamicDataDto })
	.superRefine(SaveOfferRequestDtoValidation)
export type SaveOfferRequestDto = z.infer<typeof SaveOfferRequestDto>

export const OfferCreateResponseDto = z
	.object({ wwtOfferId: z.string().uuid() })
	.superRefine(OfferCreateResponseDtoValidation)
export type OfferCreateResponseDto = z.infer<typeof OfferCreateResponseDto>

export const OffersResponseDto = z
	.object({
		hotelStatic: z.record(z.record(HotelStaticDataDto)),
		roomStatic: z.record(z.record(z.record(RoomStaticDataDto))),
		hotelDynamic: z.record(z.record(z.record(HotelDynamicDataDto))),
		roomDynamic: z.record(z.record(z.record(z.record(RoomDynamicDataDto)))),
		offers: z.array(OfferMetaDataDto)
	})
	.superRefine(OffersResponseDtoValidation)
export type OffersResponseDto = z.infer<typeof OffersResponseDto>

export const ChangelogOfferDto = z
	.object({
		hotelStatic: z
			.object({ includedFeatures: z.array(IncludedFeatureDto).min(1) })
			.partial()
			.optional(),
		roomStatic: z
			.object({ includedFeatures: z.array(IncludedFeatureDto).min(1) })
			.partial()
			.optional(),
		hotelDynamic: z
			.object({ checkInFeatures: z.array(CheckInFeatureDto).min(1) })
			.partial()
			.optional(),
		roomDynamic: z
			.object({
				includedFeatures: z.array(IncludedFeatureDto).min(1).max(2147483647),
				bookablePackagedFeatures: z
					.array(BookablePackagedFeatureDto)
					.min(1)
					.max(2147483647),
				bookableNotPackagedFeatures: z
					.array(BookableNotPackagedFeatureDto)
					.min(1)
					.max(2147483647),
				checkInFeatures: z.array(CheckInFeatureDto).min(1).max(2147483647)
			})
			.partial()
			.optional(),
		metaData: OfferMetaDataDto
	})
	.superRefine(ChangelogOfferDtoValidation)
export type ChangelogOfferDto = z.infer<typeof ChangelogOfferDto>

export const ChangelogOffersMap = z
	.record(ChangelogOfferDto)
	.superRefine(ChangelogOffersMapValidation)
export type ChangelogOffersMap = z.infer<typeof ChangelogOffersMap>

export const LikesResponseDto = z
	.object({
		content: OffersResponseDto,
		changelog: ChangelogOffersMap.optional()
	})
	.superRefine(LikesResponseDtoValidation)
export type LikesResponseDto = z.infer<typeof LikesResponseDto>

export const ResponseMessageDto = z
	.object({ message: z.string().min(1) })
	.superRefine(ResponseMessageDtoValidation)
export type ResponseMessageDto = z.infer<typeof ResponseMessageDto>

export const CreateReasonDto = z
	.object({
		offerId: z.string().uuid(),
		reason: z.array(z.string().min(1)).min(1),
		detailedDescription: z.string().min(1).optional()
	})
	.superRefine(CreateReasonDtoValidation)
export type CreateReasonDto = z.infer<typeof CreateReasonDto>

export const ReasonDto = z
	.object({
		reactionId: z.string().uuid(),
		type: z.string().min(1),
		reason: z.array(z.string().min(1)).min(1),
		detailedDescription: z.string().min(1).optional()
	})
	.superRefine(ReasonDtoValidation)
export type ReasonDto = z.infer<typeof ReasonDto>

export const DislikedOfferIdsListDto = z
	.object({ disliked: z.array(z.string()) })
	.superRefine(DislikedOfferIdsListDtoValidation)
export type DislikedOfferIdsListDto = z.infer<typeof DislikedOfferIdsListDto>

export const OfferIdsDto = z
	.object({
		integrationName: z.string().min(1),
		integrationHotelId: z.string().min(1),
		integrationRoomId: z.string().min(1)
	})
	.superRefine(OfferIdsDtoValidation)
export type OfferIdsDto = z.infer<typeof OfferIdsDto>

export const SaveDislikeResponseDto = z
	.object({ dislikeId: z.string().uuid(), disliked: z.boolean().optional() })
	.superRefine(SaveDislikeResponseDtoValidation)
export type SaveDislikeResponseDto = z.infer<typeof SaveDislikeResponseDto>

export const GenderEnum = z
	.enum(['MALE', 'FEMALE', 'NON_BINARY', 'ANOTHER', 'DONT_ANSWER'])
	.superRefine(GenderEnumValidation)
export type GenderEnum = z.infer<typeof GenderEnum>

export const AdultReservationGuestsDto = z
	.object({
		name: z.string().min(1).max(100),
		lastName: z.string().min(1).max(50),
		dateOfBirth: z.string()
	})
	.partial()
	.superRefine(AdultReservationGuestsDtoValidation)
export type AdultReservationGuestsDto = z.infer<
	typeof AdultReservationGuestsDto
>

export const ChilldrenReservationGuestsDto = z
	.object({
		name: z.string().min(1).max(100).optional(),
		lastName: z.string().min(1).max(50).optional(),
		dateOfBirth: z.string()
	})
	.superRefine(ChilldrenReservationGuestsDtoValidation)
export type ChilldrenReservationGuestsDto = z.infer<
	typeof ChilldrenReservationGuestsDto
>

export const CreateReservationDto = z
	.object({
		offerId: z.string().uuid(),
		name: z.string().min(1).max(50),
		lastName: z.string().min(1).max(50),
		email: z.string().email(),
		dateOfBirth: z.string(),
		countryCode: z.string().min(2).max(2),
		address: z.string().min(1).max(100),
		gender: GenderEnum,
		phone: z.string().min(1).max(15),
		isBusinessTrip: z.boolean(),
		comment: z.string().min(1).max(2000).optional(),
		redirectUrlAfterPayment: z.string().min(5).max(100),
		adultsList: z.array(AdultReservationGuestsDto).min(1),
		childrenList: z.array(ChilldrenReservationGuestsDto).min(1).optional(),
		petList: z.array(GuestPetDto).min(1).optional(),
		promoCodeId: z.string().uuid().optional()
	})
	.superRefine(CreateReservationDtoValidation)
export type CreateReservationDto = z.infer<typeof CreateReservationDto>

export const ReservationStatusEnum = z
	.enum([
		'CONFIRMED',
		'IN_PROCESS',
		'CANCELLED',
		'ERROR_RESERVATION',
		'ERROR_CANCEL'
	])
	.superRefine(ReservationStatusEnumValidation)
export type ReservationStatusEnum = z.infer<typeof ReservationStatusEnum>

export const SupplierInfoDto = z
	.object({ supplierName: z.string().min(1), supplierVat: z.string().min(1) })
	.superRefine(SupplierInfoDtoValidation)
export type SupplierInfoDto = z.infer<typeof SupplierInfoDto>

export const ReservationDto = z
	.object({
		reservationId: z.string().uuid(),
		offerId: z.string().uuid(),
		reservationStatus: ReservationStatusEnum,
		price: PriceDto,
		name: z.string().min(1).max(50),
		lastName: z.string().min(1).max(50),
		dateOfBirth: z.string(),
		email: z.string().email(),
		countryCode: z.string().min(2).max(2),
		phone: z.string().min(1).max(15),
		gender: GenderEnum,
		address: z.string().min(1).max(100),
		isBusinessTrip: z.boolean(),
		adultsList: z.array(AdultReservationGuestsDto).min(1),
		childrenList: z.array(ChilldrenReservationGuestsDto).min(1).optional(),
		petList: z.array(GuestPetDto).min(1).optional(),
		paymentLink: z.string().url(),
		errorMessage: z.string().min(1).optional(),
		updatedAt: z.string(),
		comment: z.string().min(1).max(2000).optional(),
		integrationBookingReference: z.string(),
		supplierInfoDto: SupplierInfoDto.optional()
	})
	.superRefine(ReservationDtoValidation)
export type ReservationDto = z.infer<typeof ReservationDto>

export const ReservationCancelledRequestDto = z
	.object({ reservationId: z.string().uuid(), language: z.string().optional() })
	.superRefine(ReservationCancelledRequestDtoValidation)
export type ReservationCancelledRequestDto = z.infer<
	typeof ReservationCancelledRequestDto
>

export const AuthenticationRequestDto = z
	.object({
		email: z.string().min(0).max(50),
		password: z.string().min(0).max(500)
	})
	.superRefine(AuthenticationRequestDtoValidation)
export type AuthenticationRequestDto = z.infer<typeof AuthenticationRequestDto>

export const JWTToken = z
	.object({ token: z.string() })
	.superRefine(JWTTokenValidation)
export type JWTToken = z.infer<typeof JWTToken>

export const SortDto = z
	.object({
		id: z.string().min(1),
		name: z.string().min(1).max(50),
		default: z.boolean().optional()
	})
	.superRefine(SortDtoValidation)
export type SortDto = z.infer<typeof SortDto>

export const SortResponseDto = z
	.object({ allSorts: z.array(SortDto).min(1) })
	.superRefine(SortResponseDtoValidation)
export type SortResponseDto = z.infer<typeof SortResponseDto>

export const Metadata = z
	.object({
		page: z.number().int().gte(0),
		sizePage: z.number().int().gte(1),
		totalElements: z.number().int().gte(1)
	})
	.superRefine(MetadataValidation)
export type Metadata = z.infer<typeof Metadata>

export const SearchResponseDto = z
	.object({ content: OffersResponseDto, metadata: Metadata })
	.superRefine(SearchResponseDtoValidation)
export type SearchResponseDto = z.infer<typeof SearchResponseDto>

export const PaginationDto = z
	.object({ limit: z.number().int(), offset: z.number().int() })
	.superRefine(PaginationDtoValidation)
export type PaginationDto = z.infer<typeof PaginationDto>

export const StayPeriodDto = z
	.object({ checkIn: z.string(), checkOut: z.string() })
	.superRefine(StayPeriodDtoValidation)
export type StayPeriodDto = z.infer<typeof StayPeriodDto>

export const StayDto = z
	.object({ defaultStayPeriod: StayPeriodDto })
	.superRefine(StayDtoValidation)
export type StayDto = z.infer<typeof StayDto>

export const PointDto = z
	.object({ latitude: z.number(), longitude: z.number() })
	.superRefine(PointDtoValidation)
export type PointDto = z.infer<typeof PointDto>

export const GeolocationDto = z
	.object({ radius: z.number().int().gte(1).lte(200), centerPoint: PointDto })
	.superRefine(GeolocationDtoValidation)
export type GeolocationDto = z.infer<typeof GeolocationDto>

export const ActiveFilterDto = z
	.object({
		id: z.string(),
		type: z.enum(['RANGE', 'AND', 'OR', 'GROUP', 'PRICE_RANGE']),
		optionIDs: z.array(z.string()).optional(),
		rangeLower: z.number().int().optional(),
		rangeUpper: z.number().int().optional(),
		iconName: z.string().optional()
	})
	.superRefine(ActiveFilterDtoValidation)
export type ActiveFilterDto = z.infer<typeof ActiveFilterDto>

export const FlagSearchDto = z
	.object({
		isSearchWithDynamicAndStaticData: z.boolean(),
		isSearchOnlyStaticData: z.boolean().optional(),
		isSearchWithRoomReviewsAndFAQ: z.boolean().optional(),
		isSearchWithBlog: z.boolean().optional(),
		isSavingRawIntegrationResponse: z.boolean().optional()
	})
	.superRefine(FlagSearchDtoValidation)
export type FlagSearchDto = z.infer<typeof FlagSearchDto>

export const HotelSearchDto = z
	.object({
		hotelId: z.string().min(1),
		rooms: z.array(z.string().min(1)).min(1).optional()
	})
	.superRefine(HotelSearchDtoValidation)
export type HotelSearchDto = z.infer<typeof HotelSearchDto>

export const IntegrationSearchDto = z
	.object({
		integrationName: z.string().min(1),
		hotels: z.array(HotelSearchDto).min(1).optional()
	})
	.superRefine(IntegrationSearchDtoValidation)
export type IntegrationSearchDto = z.infer<typeof IntegrationSearchDto>

export const SearchOffersDto = z
	.object({
		pagination: PaginationDto,
		stay: StayDto,
		geolocation: GeolocationDto,
		guestQuantity: GuestQuantityDto,
		sortBy: z.string().min(1).optional(),
		filters: z.array(ActiveFilterDto).optional(),
		flagSearch: FlagSearchDto,
		integrationsSearch: z.array(IntegrationSearchDto).min(1).max(2147483647)
	})
	.superRefine(SearchOffersDtoValidation)
export type SearchOffersDto = z.infer<typeof SearchOffersDto>

export const OfferValidationResponseDto = z
	.object({ changelog: ChangelogOfferDto.optional(), offer: OfferResponseDto })
	.superRefine(OfferValidationResponseDtoValidation)
export type OfferValidationResponseDto = z.infer<
	typeof OfferValidationResponseDto
>

export const SetModeEnum = z
	.enum(['ALL', 'DIFFERENCE', 'TOP30', 'CUSTOM_PARAMETERS'])
	.superRefine(SetModeEnumValidation)
export type SetModeEnum = z.infer<typeof SetModeEnum>

export const SetResponseDto = z
	.object({
		id: z.string().uuid(),
		title: z.string().min(1).max(50),
		mode: SetModeEnum,
		unselectedFeatures: z.array(z.string()).optional(),
		totalOffers: z.number().int().gte(0).lte(100),
		isSelected: z.boolean()
	})
	.superRefine(SetResponseDtoValidation)
export type SetResponseDto = z.infer<typeof SetResponseDto>

export const SetsResponseDto = z
	.object({ sets: z.array(SetResponseDto) })
	.superRefine(SetsResponseDtoValidation)
export type SetsResponseDto = z.infer<typeof SetsResponseDto>

export const CreateSetRequest = z
	.object({ title: z.string() })
	.superRefine(CreateSetRequestValidation)
export type CreateSetRequest = z.infer<typeof CreateSetRequest>

export const UpdateSetRequestDto = z
	.object({
		title: z.string().min(1).max(50),
		isSelected: z.boolean(),
		mode: SetModeEnum,
		unselectedFeatures: z.array(z.string()).min(1)
	})
	.partial()
	.superRefine(UpdateSetRequestDtoValidation)
export type UpdateSetRequestDto = z.infer<typeof UpdateSetRequestDto>

export const ReservationStatusDto = z
	.object({ status: ReservationStatusEnum })
	.partial()
	.superRefine(ReservationStatusDtoValidation)
export type ReservationStatusDto = z.infer<typeof ReservationStatusDto>

export const ReviewRequestDto = z
	.object({
		integrationId: z.string(),
		hotelId: z.string(),
		roomId: z.string().optional(),
		pagination: PaginationDto.optional(),
		sortBy: z.string().min(1).optional()
	})
	.superRefine(ReviewRequestDtoValidation)
export type ReviewRequestDto = z.infer<typeof ReviewRequestDto>

export const ReviewMetaDataDto = z
	.object({
		wwtReviewId: z.string(),
		sourceId: z.string(),
		locationId: z.string(),
		sourcePlatform: z.string(),
		isMachineTranslated: z.boolean().optional(),
		sourceUrl: z.string().optional(),
		languageCode: z.string().min(2).max(2).optional(),
		createdAt: z.string().optional()
	})
	.superRefine(ReviewMetaDataDtoValidation)
export type ReviewMetaDataDto = z.infer<typeof ReviewMetaDataDto>

export const ReviewAuthorDto = z
	.object({
		name: z.string(),
		helpfulVotes: z.number().int().gte(0).optional(),
		iconUrl: z.string().url().optional()
	})
	.superRefine(ReviewAuthorDtoValidation)
export type ReviewAuthorDto = z.infer<typeof ReviewAuthorDto>

export const ReviewTravelerTypeDto = z
	.object({
		category: z.string(),
		adults: z.number().int().gte(1),
		children: z.number().int().gte(0)
	})
	.partial()
	.superRefine(ReviewTravelerTypeDtoValidation)
export type ReviewTravelerTypeDto = z.infer<typeof ReviewTravelerTypeDto>

export const ReviewTripDetailsDto = z
	.object({
		travelDate: z.string(),
		durationNights: z.number().int().gte(1),
		travelerType: ReviewTravelerTypeDto,
		tripPurpose: z.string(),
		roomType: z.string()
	})
	.partial()
	.superRefine(ReviewTripDetailsDtoValidation)
export type ReviewTripDetailsDto = z.infer<typeof ReviewTripDetailsDto>

export const ReviewRatingElementDto = z
	.object({ title: z.string().min(1), score: z.number().gte(1).lte(10) })
	.superRefine(ReviewRatingElementDtoValidation)
export type ReviewRatingElementDto = z.infer<typeof ReviewRatingElementDto>

export const ReviewScoreDto = z
	.object({
		score: z.number().gte(1).lte(10),
		subratings: z.array(ReviewRatingElementDto).min(1).optional()
	})
	.superRefine(ReviewScoreDtoValidation)
export type ReviewScoreDto = z.infer<typeof ReviewScoreDto>

export const ReviewOwnerResponseDto = z
	.object({
		id: z.string(),
		title: z.string(),
		text: z.string(),
		language: z.string(),
		author: z.string(),
		publishedDate: z.string()
	})
	.partial()
	.superRefine(ReviewOwnerResponseDtoValidation)
export type ReviewOwnerResponseDto = z.infer<typeof ReviewOwnerResponseDto>

export const ReviewContentDto = z
	.object({
		title: z.string().min(1),
		good: z.array(z.string().min(1)).min(1),
		bad: z.array(z.string().min(1)).min(1),
		descriptionPositive: z.string().min(1),
		descriptionNeutral: z.string().min(1),
		descriptionNegative: z.string().min(1),
		images: z.array(ImageDto),
		ownerResponse: ReviewOwnerResponseDto
	})
	.partial()
	.superRefine(ReviewContentDtoValidation)
export type ReviewContentDto = z.infer<typeof ReviewContentDto>

export const ReviewDto = z
	.object({
		metadata: ReviewMetaDataDto,
		author: ReviewAuthorDto.optional(),
		tripDetails: ReviewTripDetailsDto.optional(),
		rating: ReviewScoreDto.optional(),
		content: ReviewContentDto.optional()
	})
	.superRefine(ReviewDtoValidation)
export type ReviewDto = z.infer<typeof ReviewDto>

export const ReviewsDto = z
	.object({ reviews: z.array(ReviewDto), averageRatings: ReviewScoreDto })
	.superRefine(ReviewsDtoValidation)
export type ReviewsDto = z.infer<typeof ReviewsDto>

export const ReviewsResponseDto = z
	.object({ content: ReviewsDto, metadata: Metadata })
	.superRefine(ReviewsResponseDtoValidation)
export type ReviewsResponseDto = z.infer<typeof ReviewsResponseDto>

export const NotificationStatusEnum = z
	.enum(['NEW', 'SHOWN_POPUP', 'VIEWED', 'RESOLVED'])
	.superRefine(NotificationStatusEnumValidation)
export type NotificationStatusEnum = z.infer<typeof NotificationStatusEnum>

export const CountElementsDto = z
	.object({ count: z.number() })
	.superRefine(CountElementsDtoValidation)
export type CountElementsDto = z.infer<typeof CountElementsDto>

export const LikeIdsResponse = z
	.record(z.string().uuid())
	.superRefine(LikeIdsResponseValidation)
export type LikeIdsResponse = z.infer<typeof LikeIdsResponse>

export const UserDto = z
	.object({
		userId: z.string().uuid(),
		email: z.string().email(),
		firstName: z.string().min(1),
		lastName: z.string().min(1).optional(),
		iconUrl: z.string().url()
	})
	.superRefine(UserDtoValidation)
export type UserDto = z.infer<typeof UserDto>

export const OfferPromoCodeRequest = z
	.object({ offerId: z.string().uuid(), promoCode: z.string().min(1) })
	.superRefine(OfferPromoCodeRequestValidation)
export type OfferPromoCodeRequest = z.infer<typeof OfferPromoCodeRequest>

export const OfferPromoCodeResponse = z
	.object({
		promoCodeId: z.string().uuid(),
		title: z.string(),
		description: z.string().optional(),
		offer: OfferResponseDto
	})
	.superRefine(OfferPromoCodeResponseValidation)
export type OfferPromoCodeResponse = z.infer<typeof OfferPromoCodeResponse>

export const ChatMessageStatusEnum = z
	.enum(['UNREAD', 'READ'])
	.superRefine(ChatMessageStatusEnumValidation)
export type ChatMessageStatusEnum = z.infer<typeof ChatMessageStatusEnum>

export const NotificationDtoRequest = z
	.object({ paginationDto: PaginationDto, status: NotificationStatusEnum })
	.superRefine(NotificationDtoRequestValidation)
export type NotificationDtoRequest = z.infer<typeof NotificationDtoRequest>

export const ChatSearchInfoFilterItemRangeParams = z
	.object({ filterId: z.string(), rangeMin: z.number(), rangeMax: z.number() })
	.superRefine(ChatSearchInfoFilterItemRangeParamsValidation)
export type ChatSearchInfoFilterItemRangeParams = z.infer<
	typeof ChatSearchInfoFilterItemRangeParams
>

export const ChatSearchInfoFilterItemOption = z
	.object({ filterId: z.string(), optionId: z.string() })
	.superRefine(ChatSearchInfoFilterItemOptionValidation)
export type ChatSearchInfoFilterItemOption = z.infer<
	typeof ChatSearchInfoFilterItemOption
>

export const ChatSearchInfoDTO = z
	.object({
		filterItemsOptions: z.array(ChatSearchInfoFilterItemOption),
		filterItemsRangeParams: z.array(ChatSearchInfoFilterItemRangeParams),
		guests: GuestQuantityDto,
		dates: StayPeriodDto,
		destination: z.string().min(1)
	})
	.superRefine(ChatSearchInfoDTOValidation)
export type ChatSearchInfoDTO = z.infer<typeof ChatSearchInfoDTO>

export const ChatMessageTextAndSearchInfoDto = z
	.object({ text: z.string().min(1), searchInfo: ChatSearchInfoDTO.optional() })
	.superRefine(ChatMessageTextAndSearchInfoDtoValidation)
export type ChatMessageTextAndSearchInfoDto = z.infer<
	typeof ChatMessageTextAndSearchInfoDto
>

export const NotificationActionRedirectToHome = z
	.object({
		action: z.literal('REDIRECT'),
		page: z.literal('HOME'),
		searchRequestParams: SearchOffersDto.optional()
	})
	.superRefine(NotificationActionRedirectToHomeValidation)
export type NotificationActionRedirectToHome = z.infer<
	typeof NotificationActionRedirectToHome
>

export const ModalEnum = z
	.literal('CHAT_ASSISTANT')
	.superRefine(ModalEnumValidation)
export type ModalEnum = z.infer<typeof ModalEnum>

export const PageEnum = z
	.enum(['COMPARISON', 'ROOM_OFFER', 'RESERVATION', 'HOME'])
	.superRefine(PageEnumValidation)
export type PageEnum = z.infer<typeof PageEnum>

export const NotificationActionEnum = z
	.enum(['REDIRECT', 'OPEN_MODAL', 'START_TUTORIAL'])
	.superRefine(NotificationActionEnumValidation)
export type NotificationActionEnum = z.infer<typeof NotificationActionEnum>

export const ChatTabEnum = z
	.enum([
		'HOME',
		'GPT',
		'CHAT_WITH_HOTEL',
		'CHAT_WITH_TRAVELLERS',
		'CHAT_WITH_GROUPS',
		'NOTIFICATIONS',
		'GAME'
	])
	.superRefine(ChatTabEnumValidation)
export type ChatTabEnum = z.infer<typeof ChatTabEnum>

export const NotificationActionOpenModalChatAssistant = z
	.object({
		action: z.literal('OPEN_MODAL'),
		modal: z.literal('CHAT_ASSISTANT'),
		tabName: ChatTabEnum.optional(),
		chatId: z.union([z.string(), z.string()]).optional()
	})
	.superRefine(NotificationActionOpenModalChatAssistantValidation)
export type NotificationActionOpenModalChatAssistant = z.infer<
	typeof NotificationActionOpenModalChatAssistant
>

export const NotificationActionStartTutorial = z
	.object({ action: z.literal('START_TUTORIAL') })
	.superRefine(NotificationActionStartTutorialValidation)
export type NotificationActionStartTutorial = z.infer<
	typeof NotificationActionStartTutorial
>

export const NotificationActionRedirectToComparison = z
	.object({
		action: z.literal('REDIRECT'),
		page: z.literal('COMPARISON'),
		setId: z.string().min(1).optional()
	})
	.superRefine(NotificationActionRedirectToComparisonValidation)
export type NotificationActionRedirectToComparison = z.infer<
	typeof NotificationActionRedirectToComparison
>

export const NotificationActionRedirectToReservation = z
	.object({
		action: z.literal('REDIRECT'),
		page: z.literal('RESERVATION'),
		wwtOfferId: z.string().uuid()
	})
	.superRefine(NotificationActionRedirectToReservationValidation)
export type NotificationActionRedirectToReservation = z.infer<
	typeof NotificationActionRedirectToReservation
>

export const NotificationActionRedirectToRoomOfferWithOfferId = z
	.object({
		action: z.literal('REDIRECT'),
		page: z.literal('ROOM_OFFER'),
		wwtOfferId: z.string().uuid(),
		searchRequestParams: SearchOffersDto.optional()
	})
	.superRefine(NotificationActionRedirectToRoomOfferWithOfferIdValidation)
export type NotificationActionRedirectToRoomOfferWithOfferId = z.infer<
	typeof NotificationActionRedirectToRoomOfferWithOfferId
>

export const NotificationDto = z
	.object({
		notificationId: z.string().uuid(),
		name: z.string().min(1),
		description: z.string().min(1),
		detailedDescription: z.string().min(1).optional(),
		status: NotificationStatusEnum,
		createdAt: z.string().datetime({ offset: true }),
		action: z.union([
			NotificationActionRedirectToComparison,
			NotificationActionRedirectToReservation,
			NotificationActionRedirectToRoomOfferWithOfferId,
			NotificationActionRedirectToHome,
			NotificationActionStartTutorial,
			NotificationActionOpenModalChatAssistant
		])
	})
	.superRefine(NotificationDtoValidation)
export type NotificationDto = z.infer<typeof NotificationDto>

export const NotificationClientListResponseDto = z
	.object({ notifications: z.array(NotificationDto) })
	.superRefine(NotificationClientListResponseDtoValidation)
export type NotificationClientListResponseDto = z.infer<
	typeof NotificationClientListResponseDto
>

export const NotificationClientUpdateRequestDto = z
	.object({
		notificationId: z.string().uuid(),
		name: z.string().min(1),
		description: z.string().min(1),
		status: NotificationStatusEnum,
		detailedDescription: z.string(),
		createdAt: z.string().datetime({ offset: true }),
		action: z.union([
			NotificationActionRedirectToComparison,
			NotificationActionRedirectToReservation,
			NotificationActionRedirectToRoomOfferWithOfferId,
			NotificationActionRedirectToHome,
			NotificationActionStartTutorial,
			NotificationActionOpenModalChatAssistant
		])
	})
	.partial()
	.superRefine(NotificationClientUpdateRequestDtoValidation)
export type NotificationClientUpdateRequestDto = z.infer<
	typeof NotificationClientUpdateRequestDto
>

export const ChatFromEnum = z
	.enum(['USER', 'GPT'])
	.superRefine(ChatFromEnumValidation)
export type ChatFromEnum = z.infer<typeof ChatFromEnum>

export const ChatMessageDTO = z
	.object({
		chatMessageId: z.string().uuid(),
		chatId: z.string().uuid(),
		from: ChatFromEnum,
		message: ChatMessageTextAndSearchInfoDto,
		createdAt: z.string().datetime({ offset: true })
	})
	.superRefine(ChatMessageDTOValidation)
export type ChatMessageDTO = z.infer<typeof ChatMessageDTO>

export const ChatClientMessagesResponse = z
	.array(ChatMessageDTO)
	.superRefine(ChatClientMessagesResponseValidation)
export type ChatClientMessagesResponse = z.infer<
	typeof ChatClientMessagesResponse
>

export const ChatClientMessagesRequest = z
	.object({ chatId: z.string() })
	.superRefine(ChatClientMessagesRequestValidation)
export type ChatClientMessagesRequest = z.infer<
	typeof ChatClientMessagesRequest
>

export const ChatClientChatUpdateRequest = z
	.object({
		chatId: z.string(),
		name: z.string().min(1).optional(),
		tabName: ChatTabEnum.optional()
	})
	.superRefine(ChatClientChatUpdateRequestValidation)
export type ChatClientChatUpdateRequest = z.infer<
	typeof ChatClientChatUpdateRequest
>

export const ChatDTO = z
	.object({
		chatId: z.string().uuid(),
		name: z.string().min(1),
		tabName: ChatTabEnum,
		updateAt: z.string().datetime({ offset: true }),
		createdAt: z.string().datetime({ offset: true })
	})
	.superRefine(ChatDTOValidation)
export type ChatDTO = z.infer<typeof ChatDTO>

export const ChatClientChatsResponse = z
	.array(ChatDTO)
	.superRefine(ChatClientChatsResponseValidation)
export type ChatClientChatsResponse = z.infer<typeof ChatClientChatsResponse>

export const ChatClientChatsRequest = z
	.object({ tabName: ChatTabEnum })
	.superRefine(ChatClientChatsRequestValidation)
export type ChatClientChatsRequest = z.infer<typeof ChatClientChatsRequest>

export const ChatClientMessageCreateResponse = z
	.object({
		sentMessage: ChatMessageDTO,
		messages: z.array(ChatMessageDTO).min(1)
	})
	.superRefine(ChatClientMessageCreateResponseValidation)
export type ChatClientMessageCreateResponse = z.infer<
	typeof ChatClientMessageCreateResponse
>

export const ChatClientMessageCreateRequest = z
	.object({
		chatId: z.string().optional(),
		tabName: ChatTabEnum,
		message: z.string().min(1)
	})
	.superRefine(ChatClientMessageCreateRequestValidation)
export type ChatClientMessageCreateRequest = z.infer<
	typeof ChatClientMessageCreateRequest
>

export const SocketSuccessResponse = z
	.object({ data: z.string() })
	.superRefine(SocketSuccessResponseValidation)
export type SocketSuccessResponse = z.infer<typeof SocketSuccessResponse>

export const SocketErrorDto = z
	.object({ name: z.string().min(1), message: z.string().min(1) })
	.superRefine(SocketErrorDtoValidation)
export type SocketErrorDto = z.infer<typeof SocketErrorDto>

export const RangeParamsDto = z
	.object({
		rangeMin: z.number().int(),
		rangeMax: z.number().int(),
		rangeStep: z.number().int(),
		isThumbTwo: z.boolean(),
		recommendedValue: z.number().int(),
		isMaxPlus: z.boolean(),
		isRecommendedAboveValue: z.boolean()
	})
	.partial()
	.superRefine(RangeParamsDtoValidation)
export type RangeParamsDto = z.infer<typeof RangeParamsDto>

export const InfoProvided = z
	.object({ id: z.string(), cavv: z.string(), eci: z.string() })
	.partial()
	.superRefine(InfoProvidedValidation)
export type InfoProvided = z.infer<typeof InfoProvided>

export const ThreeDsData = z
	.object({
		option: z.enum(['PROVIDED', 'REQUESTED']),
		version: z.string(),
		infoProvided: InfoProvided
	})
	.partial()
	.superRefine(ThreeDsDataValidation)
export type ThreeDsData = z.infer<typeof ThreeDsData>

export const PaymentCard = z
	.object({
		cardType: z.enum([
			'AMEX',
			'EURO6000',
			'JCB',
			'DINERS',
			'MASTERCARD',
			'VISA',
			'MAESTRO',
			'SWITCH',
			'SOLO_GB',
			'AIRPLUS',
			'CHINAUNIONPAY',
			'DISCOVER'
		]),
		cardNumber: z.string(),
		cardHolderName: z.string(),
		expiryDate: z.string(),
		cardCVC: z.string()
	})
	.partial()
	.superRefine(PaymentCardValidation)
export type PaymentCard = z.infer<typeof PaymentCard>

export const ContactData = z
	.object({ email: z.string(), phoneNumber: z.number().int() })
	.partial()
	.superRefine(ContactDataValidation)
export type ContactData = z.infer<typeof ContactData>

export const BillingAddress = z
	.object({
		address1: z.string(),
		address2: z.string(),
		city: z.string(),
		state: z.string(),
		postalCode: z.string(),
		countyCode: z.string()
	})
	.partial()
	.superRefine(BillingAddressValidation)
export type BillingAddress = z.infer<typeof BillingAddress>

export const Device = z
	.object({ id: z.string(), ip: z.string(), userAgent: z.string() })
	.partial()
	.superRefine(DeviceValidation)
export type Device = z.infer<typeof Device>

export const PaymentData = z
	.object({
		paymentCard: PaymentCard,
		contactData: ContactData,
		billingAddress: BillingAddress,
		threeDsData: ThreeDsData,
		webPartner: z.number().int(),
		device: Device
	})
	.partial()
	.superRefine(PaymentDataValidation)
export type PaymentData = z.infer<typeof PaymentData>

export const SaveOfferStaticDataDto = z
	.object({
		roomStaticData: RoomStaticDataDto,
		hotelStaticData: HotelStaticDataDto
	})
	.partial()
	.superRefine(SaveOfferStaticDataDtoValidation)
export type SaveOfferStaticDataDto = z.infer<typeof SaveOfferStaticDataDto>
